import { create } from "zustand";



const MAX_TIMEOUT_DELAY = 2147483647;
let promotionExpirationTimer = null;
function clearPromotionExpirationTimer() {
    if (!promotionExpirationTimer) {
        return;
    }
    clearTimeout(promotionExpirationTimer);
    promotionExpirationTimer = null;
}
function parseActivityTime(time) {
    const timestamp = new Date(time || '').getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
}
function isDiscountActivityActive(discountActivity, now = Date.now()) {
    if (!discountActivity) {
        return false;
    }
    const end = parseActivityTime(discountActivity.endTime);
    if (end === null) {
        return false;
    }
    return now < end;
}
const usePromotionStore = create((set, get)=>{
    const schedulePromotionExpirationTimer = (discountActivity)=>{
        const end = parseActivityTime(discountActivity?.endTime);
        if (end === null) {
            return;
        }
        const delay = end - Date.now();
        if (delay <= 0) {
            set({
                discountActivity: null
            });
            return;
        }
        promotionExpirationTimer = setTimeout(()=>{
            promotionExpirationTimer = null;
            const currentActivity = get().discountActivity;
            if (currentActivity !== discountActivity) {
                return;
            }
            if (isDiscountActivityActive(currentActivity)) {
                schedulePromotionExpirationTimer(currentActivity);
                return;
            }
            set({
                discountActivity: null
            });
        }, Math.min(delay + 1, MAX_TIMEOUT_DELAY));
    };
    return {
        discountActivity: null,
        setDiscountActivity: (discountActivity)=>{
            clearPromotionExpirationTimer();
            if (!isDiscountActivityActive(discountActivity)) {
                set({
                    discountActivity: null
                });
                return;
            }
            set({
                discountActivity
            });
            schedulePromotionExpirationTimer(discountActivity);
        },
        isInPromotion: ()=>{
            return isDiscountActivityActive(get().discountActivity);
        }
    };
});

export { create, usePromotionStore };
